import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Box, Tooltip, CircularProgress } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip as RechartsTooltip } from 'recharts';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import classes from '../styles';

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const defaultData = [
  {
    value: 1,
  },
  {
    value: 1,
  },
  {
    value: 1,
  },
  {
    value: 1,
  },
  {
    value: 1,
  },
  {
    value: 1,
  },
];

const PieChartWidget = ({ title, data, tooltip, loading }) => (
  <Paper elevation={2} sx={{ padding: '0 16px', height: '100%' }}>
    <Typography mb={2} pt={2} display="flex" alignItems="center" sx={classes.chartTitle}>
      {title}
      <Tooltip placement="top" title={tooltip}>
        <HelpOutlineIcon sx={{ marginLeft: '5px', fontSize: '1.3rem' }} />
      </Tooltip>
    </Typography>
    {!loading && !data.length && <Typography variant="body2">No data available</Typography>}
    {loading ? (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '220px' }}>
        <CircularProgress />
      </Box>
    ) : (
      <>
        <Box
          sx={{
            height: 200,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={data?.length ? data : defaultData}
                dataKey="value"
                nameKey="name"
                cx="50%"
                cy="50%"
                innerRadius="65%"
                outerRadius="100%"
                fill="rgba(61, 61, 61, .4)"
                startAngle={270}
                endAngle={-90}>
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color || COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <RechartsTooltip />
            </PieChart>
          </ResponsiveContainer>
        </Box>

        <Grid container spacing={1} sx={{ paddingTop: 2, paddingBottom: 2 }}>
          {data.map((entry, index) => (
            <Grid
              size={{ xs: 4, sm: 3, md: 6, lg: 4 }}
              key={entry.name}
              sx={{ display: 'flex', alignItems: 'center', paddingLeft: 1 }}>
              <Box
                component="span"
                sx={{
                  backgroundColor: entry.color || COLORS[index % COLORS.length],
                  width: 12,
                  height: 12,
                  borderRadius: '50%',
                  display: 'inline-block',
                  marginRight: 1,
                }}
              />
              <Typography
                variant="body2"
                component="span"
                sx={{
                  textOverflow: 'ellipsis',
                  overflow: 'hidden',
                  whiteSpace: 'nowrap',
                }}>
                {entry.name}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </>
    )}
  </Paper>
);

PieChartWidget.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.number.isRequired,
    }),
  ).isRequired,
  tooltip: PropTypes.string,
  loading: PropTypes.bool,
};

export default PieChartWidget;
